export function routes($stateProvider) {
    $stateProvider
        .state('app.elv.clientes', {
        url: '/clientes',
        abstract: true,
        template: '<div ui-view></div>'
    })
        .state('app.elv.clientes.list', {
        url: '/',
        title: 'Gestão de Clientes',
        template: require('./directory/directory.view.html'),
        controller: 'DirectoryClientesElevadorController',
        controllerAs: 'vm',
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        },
        role: 'elvListarClientes'
    })
        .state('app.elv.clientes.details', {
        url: '/{id}',
        title: 'Detalhes do cliente',
        template: require('./details/details.view.html'),
        controller: 'DetalhesClientesElevadorController',
        controllerAs: 'vm',
        role: 'elvListarClientes'
    });
}
routes.$inject = ['$stateProvider'];
